import axios from "axios";
import config from "@/config";
import { getToken } from "@/libs/util";
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;
const stranges={
    queryPoint:"/sys/point/queryPoint",
    newPoint:"/sys/point/newPoint",
    "fuzzyQueryPointList":"/sys/point/fuzzyQueryPointList",
    "updatePointById":"/sys/point/updatePointById/",
    
    deletePointById:'/sys/point/deletePointById',
    queryPointById:'/sys/point/queryPointById/',
    queryPointByFilter:'/sys/point/queryPointByFilter',
}
export default function(method,apiname,params,path){
    let data=params;
    if(apiname=='newPoint'){
        data={
            ...params,
        }
    }
    if(!path){
        path=''
    }
    return axios.request({
        method:method,
        url:baseUrl+stranges[apiname]+path,
        headers:{
            // token:localStorage['token'],
            token:getToken(),
            "Content-Type": "application/json; charset=utf-8"  
        },
        data:data
    })
}